import axios from 'axios'
import { mapGetters } from 'vuex'

import LogoMain from '@/vcs/_shared/LogoMain.vue'
import AuthorizationQr from './AuthorizationQr.vue'
import HelpModal from '@/vcs/_shared/modals/HelpModal.vue'
import TabletBlocker from '@/vcs/_shared/blocker/TabletBlocker.vue'

export default {
  name: 'Start',
  components: { LogoMain, AuthorizationQr, TabletBlocker },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId',
      uiBlockedRemotely: 'getRemoteBlockerStatus'
    })
  },
  data() {
    return {
      locked: true
    }
  },
  mounted() {
    this.provideDeviceIdOnStationaryDevice()
    this.stopSessionTimer()
  },
  methods: {
    closeTabletBlocker() {
      this.locked = false
    },

    provideDeviceIdOnStationaryDevice() {
      let deviceId = window.localStorage.getItem('device_id')
      if (deviceId) this.fetchCpInfo(deviceId)
    },

    fetchCpInfo(deviceId) {
      this.$blockUI()
      axios({
        method: 'get',
        url: `collection_points/${deviceId}/map`
      })
        .then((response) => {
          this.$store.commit('setCurrentCp', response.data)
          console.log('response.data', response.data)
          this.$store.commit('setServiceProviderSlug', response.data.serviceProviderSlug)
        })
        .catch((error) => {
          this.$store.commit('addLogEntry', {
            message: '/map',
            deviceId: deviceId,
            error: error,
            time: new Date()
          })
          this.$store.commit('blockUIReconnect', true)
        })
        .finally(() => {
          this.$unblockUI()
        })
    },

    openHelpModal() {
      this.$store.commit('modal/open', {
        cmp: HelpModal,
        size: 'full'
      })
    },

    goToDelivery(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$router.push('/delivery')
    },

    goToPickup(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$router.push('/pickup')
    },

    shouldRenderAuthorizationQr() {
      return this.deviceId
    },

    stopSessionTimer() {
      this.$store.commit('stopSessionTimer')
      document.removeEventListener('click', this.$clickListener)
    }
  }
}
